import { ApiResponse, postRequest } from "@/data/apiClient";

export interface AIRequest {
  url: string;
  app: string;
  context: string;
  args: {
    userId: number;
    userName: string;
  };
}
export interface AIResponse {
  response: string;
}

export const sendMessage = async (
  request: AIRequest
): Promise<ApiResponse<AIResponse>> =>
  postRequest("https://mac-alpha.micadpro.net/api/contextChat", request); // todo from config
